/**
 * Inspection categories and stages for the "Add one inspection" form. A copy
 * of azure-functions/cis/shared/stage-vocabulary.js (stages) and
 * azure-functions/cis/shared/validation.js (categories), the same lists CIS
 * Capture offers; stageVocabulary.test.js fails if either drifts. The cockpit
 * is a Vite app and cannot require the Node modules.
 */

export const CATEGORIES = [
  "Block Assembly",
  "Hull Erection",
  "Hull Outfitting",
  "Machinery Outfitting",
  "Electrical Outfitting",
  "Painting",
  "Sea Trial",
  "Others"
];

export const STAGES_BY_CATEGORY = {
  "Block Assembly": [
    "Fairing",
    "Welding",
    "Welding/Fairing",
    "Welding/Air testing",
    "Welding/Vacuum testing",
    "Welding/Air testing/Vacuum testing",
    "Air testing"
  ],
  "Hull Erection": [
    "Keel-laying",
    "Fitting/Back gouging",
    "Back gouging",
    "Fairing",
    "Welding",
    "Welding/Fairing",
    "Welding/Vacuum testing",
    "Vacuum testing",
    "Air testing",
    "Structural testing",
    "Measurement",
    "Final visual inspection"
  ],
  "Hull Outfitting": [
    "Fitting",
    "Insulation Installation",
    "A60 Insulation Fitting",
    "Welding",
    "Welding/Final",
    "Hydrotesting",
    "Water testing",
    "Pressure testing",
    "Leak testing",
    "Hose testing",
    "Vacuum test",
    "Ultrasonic testing",
    "Overload testing",
    "Brake testing",
    "Flushing",
    "Running test",
    "Function test",
    "Operation testing",
    "Visual",
    "Visual/Operation testing",
    "Measurement/Shaft alignment"
  ],
  "Machinery Outfitting": [
    "Material Verification",
    "Material Verification/Final Inspection",
    "Fitting",
    "Insulation Fitting",
    "Welding/Hydrotesting",
    "Hydrotesting",
    "Pressure testing",
    "Water testing",
    "Air testing",
    "Flushing",
    "Cleaning",
    "Tank Cleaning",
    "Tank Closing",
    "Measurement",
    "Measurement/Shaft centering",
    "Measurement/Leak testing",
    "Final Machining",
    "Function testing",
    "Operation testing",
    "Jack-up Testing",
    "Load Testing"
  ],
  "Electrical Outfitting": [
    "Wiring Installation",
    "Fitting",
    "Measurement",
    "Automatic Control Testing",
    "Function testing",
    "Operation testing"
  ],
  "Painting": [
    "Surface Preparation",
    "Surface Preparation (Blasting)",
    "Surface Preparation (Power Tool Cleaning)",
    "Final Coating",
    "Final Coating & Tank Closing",
    "Tank Closing"
  ],
  "Sea Trial": [
    "Operation testing"
  ],
  "Others": [
    "Design/Inspection",
    "Outfitting",
    "Machinery Outfitting",
    "Painting",
    "Hydrotesting",
    "Measurement",
    "Launching"
  ]
};
